class BrandIndex extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('[data-search]');
    if (!this.form) return;
    this.input = this.querySelector('[data-input]');
    this.items = Array.from(this.querySelectorAll('[data-name]'));
    this.groups = Array.from(this.querySelectorAll('[data-group]'));
    this.letters = Array.from(this.querySelectorAll('[data-letter]'));
    this.empty = this.querySelector('[data-empty]');
    this.form.hidden = false;
    this.form.addEventListener('submit', (event) => event.preventDefault());
    this.input.addEventListener('input', () => this.filter());
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.clear();
    });
    const clear = this.querySelector('[data-clear]');
    if (clear) clear.addEventListener('click', () => this.clear());
  }

  clear() {
    this.input.value = '';
    this.filter();
    this.input.focus();
  }

  filter() {
    const query = this.input.value.trim().toLowerCase();
    let visible = 0;
    this.items.forEach((item) => {
      const hit = query === '' || item.dataset.name.includes(query);
      item.hidden = !hit;
      if (hit) visible += 1;
    });
    this.groups.forEach((group) => {
      group.hidden = !group.querySelector('[data-name]:not([hidden])');
    });
    this.letters.forEach((letter) => {
      const group = this.groups.find((candidate) => candidate.dataset.group === letter.dataset.letter);
      const off = !group || group.hidden;
      letter.classList.toggle('brand-index__letter--empty', off);
      letter.setAttribute('aria-disabled', off ? 'true' : 'false');
      letter.tabIndex = off ? -1 : 0;
    });
    this.empty.hidden = visible > 0;
  }
}

if (!customElements.get('brand-index')) customElements.define('brand-index', BrandIndex);
